<template>
  <div>
    <b-columns>
      <b-column
        v-for="(protection, idx) in agentProtections"
        :key="idx"
      >
        <div class="has-text-weight-semibold">
          {{ protection.level }}
        </div>
        <hr v-if="!isDense">
        <div>
          <p class="has-text-weight-semibold">Guide</p>
          <div class="wrap-text">
            {{ protection.guide }}
          </div>
        </div>
        <div v-if="protection.guide_pdf">
          <pdf-link :url="protection.guide_pdf" />
        </div>
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PdfLink from '@/components/structures/PdfLink'

export default {
  components: {
    PdfLink
  },
  props: {
    isDense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['agentProtections'])
  }
}
</script>

<style>
</style>
